// extracted by mini-css-extract-plugin
module.exports = {"remove_position_info":"RangeActionInfo_remove_position_info__1zBNE","token_price":"RangeActionInfo_token_price__2Iut_","ambi_info_text":"RangeActionInfo_ambi_info_text__1NNoJ"};